import { render, staticRenderFns } from "./UserLocationDelete.vue?vue&type=template&id=0c4e8a58"
import script from "./UserLocationDelete.vue?vue&type=script&lang=js"
export * from "./UserLocationDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports